const TeamImpressumData = [
    {   index:0,
        id: 'Kati',
        name: "Kati Schmidt",
        description: 'Als Gründerin von "Ei-der-Daus" verwandle ich Eierschalen mit präziser Technik in filigrane Kunstwerke und teile mein Können in Workshops, während ich meinen Traum einer Stadtwerkstatt in Bautzen lebe.',
        backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Kati_Schmidt/Ei-der-Daus-Eierfräsen.PNG',
        portrait: process.env.REACT_APP_PUBLIC_URL +'/Kati_Schmidt/Portrait_Kati_Schmidt.jpeg',
        images: [process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/Ei_der_Daus_Käfigei.jpeg",
        process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/Ei_der_Daus_Ei.jpg",
        process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/Kati_Schmidt_Stadtwerkstadt.JPG",
        process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/Ei-der-Daus-Geschenk.PNG",
        process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/Ei_der_Daus_Verkauf.jpeg",
        process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/Ei_der_Daus_Eierkunst.PNG"],
        socialLinks: {
          instagram: "https://www.instagram.com/ei__der_daus/",
          facebook: "https://www.facebook.com/profile.php?id=100073333073365&ref=xav_ig_profile_web",
          website: "https://stadtwerkstatt-bautzen.de",
        },
      leader:'Inhaberin von Ei-der-Daus und der StadtWerkstadt',
      address:'Heringstraße 19, 02625 Bautzen',
      email: 'meinert.kati@freenet.de',
      mobile: '+49 176 50494712',
      fon:'+49 3591 272668',
      vatID:'204 269 02711',
      descriptionInfo: 'Kleinunternehmerin iSv § 19 UStG',
      detailedExpo:`Ich bin Kati Schmidt, eine gelernte Zahnarzthelferin und Prophylaxe-Assistentin & Betriebswirtin der Zahnmedizin die ihre Leidenschaft für Kunst in der wunderschönen Stadt Bautzen auslebt. Neben meiner Arbeit in der Dentalbranche widme ich mich der Kunst, insbesondere der Verwandlung von einfachen Eiern in kleine, filigrane Kunstwerke unter meinem Label „Ei-der-Daus“. Vor etwa acht Jahren begann ich, mit einem tragbaren Zahnarztgerät Muster in die zerbrechlichen Schalen zu fräsen, ein Unterfangen, das anfangs mehr Bruch als Kunst produzierte. Doch ich gab nicht auf, verfeinerte meine Technik und entdeckte, dass Eier von Bio-Hühnern mit ihren dickeren Schalen ideal für meine Arbeit sind. Heute erinnern meine Kreationen an filigrane Lochspitze und sind auf Handwerkermärkten sehr gefragt. Ich gebe mein Wissen auch in Workshops weiter, um andere in dieser einzigartigen Kunstform zu unterrichten.


<f>Mein Traum</f> war es immer, einen Raum zu schaffen, in dem Kunst und Handwerk aufeinandertreffen und sich gegenseitig bereichern. Diesen Traum habe ich mit der Eröffnung meiner Stadtwerkstatt in Bautzen verwirklicht. Nach einem Fahrradunfall, bei dem ich mir das Schlüsselbein zertrümmerte, wurde mir klar, dass ich meine Träume nicht aufschieben sollte. Mit harter Arbeit und Entschlossenheit habe ich die ehemaligen Büroräume in der Steinstraße 15 in einen Ort voller Kreativität und Inspiration verwandelt. Die Wände strahlen in Dunkelgrün und warmem Grau, und der Raum ist gefüllt mit Kunst und Handwerksarbeiten, nicht nur von mir, sondern auch von anderen talentierten Kunsthandwerkern aus der Region.


<f>Die Stadtwerkstatt</f> ist ein kollektiver Raum, den ich mit sieben anderen Kunsthandwerkern teile. Wir bieten nicht nur unsere Waren zum Verkauf an, sondern auch Workshops und Veranstaltungen, um die Gemeinschaft zu fördern und unser Handwerk zu teilen. Von Töpferei, handgefertigtem Schmuck, wunderschönen Büchern, Wein aus unserer Region, handgebrautem Bier über Malerei bis hin zu einzigartigen Dekorationen – unsere Vielfalt ist unser Stärke. Ich bin stolz darauf, dass ich dieses Projekt vollständig aus eigener Tasche finanziert habe, getreu meinem Motto: Geht nicht, gibt es nicht.


Es ist mir eine Freude, diese einzigartige Form der Kunst zu teilen und anderen die Möglichkeit zu geben, ihr eigenes Unikat in einem unserer Workshops zu erschaffen.`,
      paypal:false,
    },
/*
    {   index:3,
        id: 'Thomas',
        name: "Thomas Liebig",
        description: 'Ich bin Thomas Liebig, ein Künstler, inspiriert von der Natur meiner Heimat Oberlausitz.',
        backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Thomas_Liebig/Thomas_Liebig_Bild.jpg',
        portrait: process.env.REACT_APP_PUBLIC_URL +'/Thomas_Liebig/Portrait_Thomas_Liebig.JPEG',
        images: [
          process.env.REACT_APP_PUBLIC_URL +"/Thomas_Liebig/Thomas_Liebig_Bild_Bautzen.PNG",
          process.env.REACT_APP_PUBLIC_URL +"/Thomas_Liebig/Thomas_Liebig_Stadtwerkstadt.jpeg",
          process.env.REACT_APP_PUBLIC_URL +"/Thomas_Liebig/Thomas_Liebig_Kunst.jpeg",
          process.env.REACT_APP_PUBLIC_URL +"/Thomas_Liebig/Thomas_Liebig_Eule.jpeg",
          process.env.REACT_APP_PUBLIC_URL +"/Thomas_Liebig/Thomas_Liebig_Karte.jpeg",
          process.env.REACT_APP_PUBLIC_URL +'/Thomas_Liebig/Thomas_Liebig_Bild.jpg'],
        socialLinks: {
          instagram: "https://www.instagram.com/liebig.thomas/",
          facebook: "https://www.facebook.com/thomas.liebig.777",
          website: "http://www.gestaltungstechnik-liebig.de/",
        },
        leader:'Inhaber von Gestaltungstechnik-Liebig',
        address:'Am Wassertrog 4, 02625 Bautzen',
        email: 'info@gestaltungstechnik-liebig.de',
        mobile: '+49 172 9719016',
        vatID:'204 245 01442',
        descriptionInfo: 'Kleinunternehmer iSv § 19 UStG',
        detailedExpo:`Die Malerei habe ich schon als Kind von meinem Großvater mitbekommen, ich liebte es ihn beim Malen von Vögeln, Katzen, Fuchs und Tauben zuzusehen. Ich besuchte in der Schulzeit aktiv den Zeichenzirkel wo ich die ersten Techniken erlernte. Später erlernte ich in der Volkshochschule weitere Maltechniken. Da mir das nicht ausreichte und ich unbedingt noch mehr über Malerei, Airbrush, Graffiti und Drucktechniken erlernen wollte nahm ich Unterricht bei Heike Dittrich in Bautzen für mehrere Jahre. Die Ölmalerei, Acryl und Aktmalerei interessierte mich. Später Besuchte ich in Dresden Kurse der Spachteltechnik bei Heidi Gerstner. Ich probierte viel im Eigenstudium und  besuchte viele Künstler um mehr wissen zu erlangen. Besondere Künstler wie Jahan Christian Dahl, Caspar David Friedrich, Elisabeth von Eicken, Otto Dix, Lea und Hans Grundig, Isaak Lewitan und andere genossen meine besondere Aufmerksamkeit.
        
        Ich bin immer begeistert Eindrücke und Momente einzufangen und diese in einem Bild festzuhalten. Für mich ist die Heimat sehr wichtig und deshalb sind viele Motive aus der Lausitz. Aber auch Italien oder die Ostsee sind ein gutes Bild wert. Oft verarbeite ich auch meine Träume und Wünsche, verarbeite meine Sorgen und mein Glück in den Bildern. Ich möchte gerne bleibende Lichtpunkte dieser Zeit setzen und für die Nachwelt erhalten. Auch interressiert mich sehr was die Menschen in meinen Bildern sehen!
        Ich möchte hier Kurse in Aquarell, Spachteltechnik, Acryl und Öl anbieten für Kinder in den Ferien, Erwachsene, Senioren, Kindergeburtstage, Vereinstreffen oder Firmenworkshops. Es soll ein Einblick geben wie leicht es ist Kunst selbst zu erleben und zu schaffen. Neue Techniken zu probieren, und vielleicht auch den einen oder anderen in ein neues Hobby einzuführen.
        
        <f>Ausstellungen:</f> Cham Schweiz, Vaduz Liechtenstein, Baden-Baden, Colmar Frankreich, Straßburg Frankreich, Brüssel Belgien, Oberbaumbrücke Berlin, Alte Münze Berlin, Weißenberg, Bautzen, Hochkirch und Kamenz
        `,
        paypal:false,
    },*/
    {   index:3,
        id: 'LichtMetta',
        name: "Robin Henke",
        description: 'Wir sind Robin und Laura – das Herz von LichtMetta. In unserer kleinen Manufaktur gestalten wir handgefertigte Lichtobjekte, die Wärme, Achtsamkeit und Design vereinen.',
        backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Lichtmetta/Produktion-Lichtmetta.jpeg',
        portrait: process.env.REACT_APP_PUBLIC_URL +'/Lichtmetta/Vorstellung-Lichtmetta.jpeg',
        images: [process.env.REACT_APP_PUBLIC_URL +"/Lichtmetta/Produktion-Lichtmetta.jpeg",
        process.env.REACT_APP_PUBLIC_URL +"/Lichtmetta/Bautzen-Windlicht-Lichtmetta.jpeg",
        process.env.REACT_APP_PUBLIC_URL +"/Lichtmetta/Bautzen-Windlicht-Lichtmetta-groß.jpeg",
        process.env.REACT_APP_PUBLIC_URL +"/Lichtmetta/Bautzen-Windlicht-Lichtmetta-klein.jpeg",
        process.env.REACT_APP_PUBLIC_URL +"/Lichtmetta/Gussverfahren-Lichtmetta.jpeg",
        process.env.REACT_APP_PUBLIC_URL +"/Lichtmetta/Kätzchen-Lichtmetta.jpeg"],
        socialLinks: {
          instagram: "https://www.instagram.com/lichtmetta/",
          facebook: "https://www.facebook.com/profile.php?id=61582594840017",
          website: "https://lichtmetta.de",
        },
      leader:'Inhaber von LichtMetta',
      address:'Siedlungsweg 9, 02627 Kubschütz',
      email: 'robin.henke@lichtmetta.de',
      mobile: '+49 152 54232469',
      descriptionInfo: 'Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE356893092',
      detailedExpo:`Wir sind Robin und Llaura, das Herz und die Hände hinter <f>LichtMetta</f> – einer kleinen Manufaktur, die Lichtobjekte mit Seele erschafft.
Unsere gemeinsame Leidenschaft gilt dem <f>Zusammenspiel von Design, Handwerk und Atmosphäre</f> – Dingen, die nicht nur schön aussehen, sondern ein Gefühl hinterlassen: Wärme, Ruhe und ein Stück Geborgenheit.


Der Name LichtMetta vereint genau das, was uns inspiriert:
<f>„Licht“<f> steht für Hoffnung, Wärme und Verbundenheit.
<f>„Metta“</f> kommt aus dem Pali und bedeutet liebende Güte – der achtsame Wunsch, dass es allen Lebewesen gut geht.
Gemeinsam stehen diese beiden Worte für unsere Vision:

mit jedem Lichtobjekt ein bisschen Güte und Helligkeit in den Alltag zu bringen.


In unserer Werkstatt fertigen wir handgegossene Teelichthalter, Lampen und Dekolichtobjekte, die durch klare Formen, feine Materialien und liebevolle Details überzeugen.
Dabei verbinden wir traditionelles Guss-Handwerk mit moderner Gestaltung – jedes Stück ist ein Unikat, gefertigt mit Zeit, Sorgfalt und Hingabe.


Neben unseren Kollektionen bieten wir auch <f>individuelle Anfertigungen</f> an:
vom 3D-Druck über Lasergravuren bis hin zu personalisierten Lichtobjekten, die ganz nach euren Wünschen entstehen.
So wird jedes Produkt zu einem Ausdruck eurer Persönlichkeit – und trägt unsere gemeinsame Idee weiter:
Licht schafft Verbindung.


Wir glauben daran, dass kleine Dinge Großes bewirken können –
ein Teelicht, das den Abend erhellt,
eine Flamme, die Erinnerungen weckt,
ein Objekt, das mit Liebe gestaltet wurde.


Das ist LichtMetta:
<f>Mit Liebe gestaltet – mit Licht gefüllt.</f> ✨`,
  paypal:false,
    },
/*
    {index:9,
        id: 'Anke & Katrin',
        name: "Katrin Bandke",
        description: 'Wir sind, Katrin und Anke, aus Greiz und Dresden. Uns verbindet eine tiefe Freundschaft und die Begeisterung für alles Alte.',
        backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/AnkeSeidel_KatrinBandke/VomTischZurTafel.jpg',
        portrait: process.env.REACT_APP_PUBLIC_URL +'/AnkeSeidel_KatrinBandke/Portrait_AnkeSeidel_KatrinBandke.jpeg',
        images: [process.env.REACT_APP_PUBLIC_URL +"/AnkeSeidel_KatrinBandke/Etagere_VomTischZurTafel_klein.jpg",
        process.env.REACT_APP_PUBLIC_URL +"/AnkeSeidel_KatrinBandke/VomTischZurTafel_inStadtwerkstatt.jpeg",
        process.env.REACT_APP_PUBLIC_URL +"/AnkeSeidel_KatrinBandke/Stadtwerkstatt_VomTischZurTafel.jpeg",
        process.env.REACT_APP_PUBLIC_URL +"/AnkeSeidel_KatrinBandke/Etagere_VomTischZurTafel.JPEG",
        process.env.REACT_APP_PUBLIC_URL +"/AnkeSeidel_KatrinBandke/Ohrringe_VomTischZurTafel.jpeg",
        process.env.REACT_APP_PUBLIC_URL +'/AnkeSeidel_KatrinBandke/VomTischZurTafel.jpg'],
        socialLinks: {
          instagram: "https://www.instagram.com/vomtischzurtafel/",
          facebook: "https://www.facebook.com/vomtischzurtafel.de",
          website: "https://vomtischzurtafel.de/",
        },
        leader:'Inhaberin von VomTischzurTafel',
        address:'Ortsstrasse 45, 07987 Mohlsdorf-Teichwolframsdorf ',
        email: 'Kontakt@vomtischzurtafel.de',
        mobile: 'Katrin: +49 179 3471433, Anke: +49 179 3471433',
        vatID:'166 299 24314',
        descriptionInfo: 'Kleinunternehmer/in iSv § 19 UStG',
        detailedExpo:`Wir sind Katrin und Anke.
        Wir teilen eine jahrelange Freundschaft und die Liebe zu Sammeltassen.
        Gemeinsam aufgewachsen in Greiz verbinden uns Kreativität und Leidenschaft.
        Katrin blieb im schönen Vogtland, arbeitete viele Jahre als Krankenschwester auf Kinder- und Entbindungsstationen und entschied sich 2023 für die hauptberufliche Mitwirkung im familiengeführten Landwirtschaftsbetrieb. Dort baute sie unter anderem einen Hofladen auf und beschäftigte sich intensiv mit der Eierproduktion in Mobilställen. Artgerechte Haltung, regionale Produktion und gesunde Produkte - dafür stehen ihre “Gottesgrüner Wiesenhühner”. 
        Anke verschlug es nach Dresden, wo sie als Lehrerin an einem Förderzentrum für Hörgeschädigte tätig ist.   
        2021 stattete Anke die Scheunenhochzeit eines befreundeten Paares stilsicher mit Sammeltassen aus. Diese allzu oft auf Dachböden, in Vitrinen und Truhen verborgenen und mit Geschichten besetzten Schätze stellen wir seit 2022 über unseren Verleih für eure Feste und Feiern zur Verfügung. “VomTischzurTafel” ist im Raum Dresden und dem Vogtland für euch da.
        Daneben fertigen wir Etageren und Schmuck aus Gedecken, Einzelteilen und Scherben, die ihr in der Stadtwerkstatt erwerben könnt. Und auch eure Sammeltassen verwandeln wir gern in einen echten Blickfang auf eurem Tisch. Oder soll es doch lieber ein Schmuckstück sein? 
        
        Verzaubert eure Gäste mit nostalgischen Tischgedecken und Etageren!

        “VomTischzurTafel” - Jedes Gedeck so einzigartig wie der Moment.
        
        `,
        paypal:false,
    },*/
    /*
    {index:12,
        id: 'Martin',
        name: "Martin Wagner",
        description: 'Ich bin Martin Wagner von der Sächsischen Spirituosenmanufaktur, wo wir aus regionalen Zutaten edle Liköre, Brände und Geiste herstellen.',
        backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Martin_Wagner/Sortiment_Martin_Wagner.jpg',
        portrait: process.env.REACT_APP_PUBLIC_URL +'/Martin_Wagner/Portrait_Martin_Wagner.PNG',
        images: [ process.env.REACT_APP_PUBLIC_URL +"/Martin_Wagner/Martin_Wagner_Stadtwerkstatt.jpeg",
        process.env.REACT_APP_PUBLIC_URL +"/Martin_Wagner/Auswahl_Spirituosenmanufaktur.jpg",
        process.env.REACT_APP_PUBLIC_URL +"/Martin_Wagner/Martin_Wagner_Ausschank.jpg",
        process.env.REACT_APP_PUBLIC_URL +"/Martin_Wagner/Auswahl_Martin_Wagner.jpeg",
        process.env.REACT_APP_PUBLIC_URL +"/Martin_Wagner/Saechsische_SpirituosenManufaktur.jpeg",
        process.env.REACT_APP_PUBLIC_URL +'/Martin_Wagner/Sortiment_Martin_Wagner.jpg'],
        socialLinks: {
          instagram: "https://www.instagram.com/saechsische.spirituosen/",
          facebook: "https://www.facebook.com/SaechsischeSpirituosenmanufaktur/",
          website: "https://www.saechsische-spirituosenmanufaktur.de/",
        },
        leader:'Inhaber von der Sächsische Spirituosenmanufaktur',
        address:'Waldstraße 30, 02681 Schirgiswalde-Kirschau',
        email: 'post@saechsische-spirituosenmanufaktur.de',
        fon: '+49 3592 3559630',
        descriptionInfo: 'Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE815569151',
        detailedExpo:`Bei uns wird man keine Massenware finden, denn wir produzieren ausschließlich kleine Mengen hochwertigster Spirituosen getreu dem Motto Qualität vor Quantität.

        In unserer Sächsischen Spirituosenmanufaktur wollen wir Genuss sowie Freude mit unseren hochwertigen, ausgefallenen und seltenen Spirituosen verbreiten.
        Ich lade euch ein, in die Welt der Liköre, Brände und Geiste aus regionalen Früchten, Blüten, Kräutern und Gewürzen.

Kommt in die StadtWERKSTATT und probiert das ein oder andere ….
Zusätzlich biete ich euch individuelle Tasting-Abende in der StadtWERKSTATT an, die ihr demnächst im Veranstaltungskalender findet.

`,
paypal:false,
    },*//*
    {index:12,
      id: 'Steffi',
      name: "Stefanie Schreiber",
      description: 'Ich bin Steffi, Gründerin von "Piepston & Lichterzauber", und kreiere in Doberschau einzigartige Keramik aus Ton.',
      backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Stefanie_Schreiber/Töpferware_Kerze.jpeg',
      portrait: process.env.REACT_APP_PUBLIC_URL +'/Stefanie_Schreiber/Portrait_Stefanie_Schreiber.jpeg',
      images: [ process.env.REACT_APP_PUBLIC_URL +"/Stefanie_Schreiber/Töpferware_Teller.jpeg",
      process.env.REACT_APP_PUBLIC_URL +"/Stefanie_Schreiber/Töpferware_Kerze.jpeg",
      process.env.REACT_APP_PUBLIC_URL +"/Stefanie_Schreiber/Töpferware_Figuren.jpeg",
      process.env.REACT_APP_PUBLIC_URL +"/Stefanie_Schreiber/Töpferware_Haus.jpeg",
      process.env.REACT_APP_PUBLIC_URL +"/Stefanie_Schreiber/Töpferware_Rosenmuster.jpeg",
      process.env.REACT_APP_PUBLIC_URL +'/Stefanie_Schreiber/Töpferware_bunt.jpeg'],
      socialLinks: {
        instagram: "https://www.instagram.com/piepston.lichterzauber/",
        
      },
      leader:'Inhaber von Piepston & Lichterzauber',
      address:'Friedensweg 1b, 02692 Doberschau',
      email: 'piepston.lichterzauber@web.de',
      fon: '+49 174 4335449',
      vatID:'3204 271 03030',
      descriptionInfo: 'Kleinunternehmer/in iSv § 19 UStG',
      detailedExpo:`Ich bin Steffi und Gründerin von Piepston & Lichterzauber. In meiner kleinen Werkstatt modellieren ich aus Ton individuelle Keramik und kann dabei meiner Kreativität den nötigen Raum geben. Es kann heilsam sein, Etwas mit seinen eigenen Händen zu schaffen und Euch damit ein Lächeln zu schenken.
     
      Ich lebe mit meiner Familie im beschaulichen Doberschau. Schon als Kind war ich sehr kreativ, habe mich in Vielem ausprobiert. Die Leidenschaft zum Töpfern hat mich aber erst von knapp 2 Jahren gepackt. Aus den ersten Arbeiten ist schnell der Wunsch nach einer Werkstatt und einem eigenen Ofen gewachsen und so haben wir im ehemaligen Kinderzimmer eine Werkstatt mit eigenem Ofen eingerichtet. Das Medium Ton ist so vielfältig, das sobald die Hände im Ton stecken, die Ideen nur so sprudeln. Ein fantastischer Ausgleich...


In der StadtWerkstatt findet Ihr zukünftig individuelle Keramik zum Mitnehmen, allerdings freue mich auch über Anfragen zu besonderen Anlässen... Dann bitte einfach Kontakt zu mir aufnehmen. 


`,
paypal:false,
  },*/
   /*
    {index:12,
      id: 'Sarah',
      name: "Sarah Wićaz",
      description: 'Ich bin Sarah Wićaz, Illustratorin und kreative Abenteurerin mit Liebe zu Natur und Sport.',
      backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Sarah_Wicaz/Illustrierung_Segelboot.jpeg',
      portrait: process.env.REACT_APP_PUBLIC_URL +'/Sarah_Wicaz/Portrait_Sarah_Wicaz.jpeg',
      images: [ process.env.REACT_APP_PUBLIC_URL +"/Sarah_Wicaz/Illustrierung_Strand.jpeg",
      process.env.REACT_APP_PUBLIC_URL +"/Sarah_Wicaz/Illustrierung_Kueche.jpeg",
      process.env.REACT_APP_PUBLIC_URL +"/Sarah_Wicaz/Illustrierung_Segelboot.jpeg",
      process.env.REACT_APP_PUBLIC_URL +"/Sarah_Wicaz/Illustrierung_Herz.jpeg",
      process.env.REACT_APP_PUBLIC_URL +"/Sarah_Wicaz/Fussball_Illustrierung.jpeg",
      process.env.REACT_APP_PUBLIC_URL +"/Sarah_Wicaz/Illustration_Schulkind.jpeg"],
      socialLinks: {
        instagram: "https://www.instagram.com/sawicaz?igsh=anlwMGtudzl2cmli&utm_source=qr",
       
      },
      leader:'',
      address:'Kurt-Pchalek-Str. 1, 02625 Bautzen',
      email: 'sarahwicaz@gmail.com',
      mobile:'+49 172 2602566',
      vatID:'204 287 06189',
      descriptionInfo: 'Kleinunternehmer/in iSv § 19 UStG',
      detailedExpo:`Ich bin Sarah, Erzieherin und Illustratorin. Durch meine täglichen kleinen und großen
      Abenteuer, Ausflüge, Reisen und Wandertouren werde ich zu meinen Werken inspiriert.
      Quellen dieser Inspiration sind vor allem das Wasser, der Wald und alte Häuser. In einem
      Moment des kreativen Flows mit passender akustischer Hintergrundkulisse, entfalten sich
      gestalterische Kräfte, die ich auf Papier festhalte. Das Format der Postkarte stellte sich als
      reisetauglich heraus, sodass ich auch unterwegs, on the road, vor Ort kreativ werden kann.
      Diese Originale und Prints in verschiedenen Größen könnt ihr nun hier in der Stadtwerkstatt
      erwerben.

      
      Mit der Stadtwerkstatt habe ich einen Ort gefunden, an dem ich meine Werke der
      Öffentlichkeit präsentieren und zugänglich machen kann. So ein Ort schwebte mir schon
      lange vor und bei einem Gang in die Stadt lief ich am Laden vorbei. Neugierig betrat ich die
      Location, kam ins Gespräch und bin nun Teil eines tollen Projektes, welches Künstler und
      Macher der Region verbindet.
      Studiert habe ich Kunst und Englisch in Dresden, meine Examensausstellung präsentierte
      ich im Steinhaus in Bautzen, eine weitere folgte im Grünen Laden in Bautzen. Meine
      künstlerischen Fähigkeiten habe ich bei Gerhard Nath und Heike Dittrich im Steinhaus
      Bautzen schulen können, später wurde ich mit Stoffen nach Anleitung und Inspiration durch
      Petra Hörenz-Freiberg kreativ.
      Heute fasziniert mich die Aquarellmalerei mit ihren lebendigen und zufälligen Eigenschaften.`,
      paypal:false,
  },

{index:15,
  id: 'Simone',
  name: "Simone Wujanz",
  description: 'Ich bin Simone Wujanz von Farbrausch Oberlausitz und lasse aus meiner Leidenschaft für Farben und Design einzigartigen Schmuck entstehen.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Simone_Wujanz/Simone_Wujanz_Armband.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Simone_Wujanz/Portrait_Simone_Wujanz.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Simone_Wujanz/Simone_Wujanz_Armband.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Simone_Wujanz/Simone_Wujanz_Lampe.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Simone_Wujanz/Simone_Wujanz_Halskette.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Simone_Wujanz/Simone_Wujanz_Ohrringe.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Simone_Wujanz/Simone_Wujanz_Mosaik.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Simone_Wujanz/Simone_Wujanz_Postkarte.jpeg"],
  socialLinks: {
    instagram: "https://www.instagram.com/farbrausch_oberlausitz/",
    website: "https://www.etsy.com/shop/FarbrauschOL",
  },
  leader:'Inhaber von Farbrausch Oberlausitz',
  address:'Ringstraße 15, 02681 Schirgiswalde-Kirschau',
  email: 'monewu@web.de',
  fon:'+49 3592/544037',
  mobile:'+49 15204160818',
  vatID:'204 289 01240',
  descriptionInfo: 'Kleinunternehmer/in iSv § 19 UStG',
  detailedExpo:`Ich bin schon immer ein sehr kreativer Mensch gewesen und liebe es, Dinge selbst zu erschaffen. Dabei bin ich sehr vielseitig unterwegs: Acrylmalerei, grafische Techniken, Aktzeichnung, Collagetechniken, Handarbeiten, Mosaikarbeiten aus Fliesenbruch…und seit Anfang 2023 eine eigene Schmuckkollektion.

  Meine über 30jährige Lehrtätigkeit als Kunsterzieherin musste ich nach einer schweren Erkrankung aufgeben und habe mich nun beruflich neu orientiert.
  
  Mit Hilfe einer Zufallstechnik lasse ich Farbflächen entstehen, welche dann in die entsprechenden Rohlinge (Cabochons) eingearbeitet werden. So entstehen wunderschöne, einzigartige Schmuckstücke in kräftigen Farben. Jedes Stück ist ein Unikat und durch seine Farbigkeit und sein ungewöhnliches Design ein absoluter Hingucker. Ich liebe die Arbeit an meiner Kollektion, was man den Schmuckstücken einfach ansieht : )
  
  Auch kleine Gebrauchsgegenstände wie Lesezeichen, Weinstopper, Schlüsselanhänger oder Manschettenknöpfe stelle ich her, die sich wunderbar zum Verschenken eignen. Meine handgefertigten Karten zu allen Anlässen sind natürlich auch etwas ganz Besonderes.
  
  Ich freue mich sehr, ein Teil der Stadtwerkstatt Bautzen zu sein. Ich finde dieses Projekt einfach toll und sehr wichtig für unsere Region. Einheimische Künstler und Kreative können sich vor Ort präsentieren und ihre Werke an den Mann ( bzw. in meinem Fall vorwiegend an die Frau 😊) bringen. Also keine Massenprodukte „von der Stange“…sondern einzigartig, handgemacht und aus der Region. Dabei wünsche ich unserem Team viel Erfolg!`,
  paypal:false,
},*/
/*{index:15,
  id: 'Annett',
  name: "Annett Mucke",
  description: 'Ich bin Annett, Kreativkopf, Floristin & Nähmaus.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Annett_Mucke/Annett_Mucke_Babytuch.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Annett_Mucke/Portrait_Annett_Mucke.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Annett_Mucke/Annett_Mucke_Jacke.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Annett_Mucke/Annett_Mucke_Cover.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Annett_Mucke/Annett_Mucke_Armbänder.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Annett_Mucke/Annett_Mucke_Deko.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Annett_Mucke/Annett_Mucke_Babytuch.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Annett_Mucke/Annett_Mucke_Kissen.jpeg"],
  socialLinks: {
    instagram: "https://www.instagram.com/annett_rosea/",
  },
  leader:'Inhaber von roseA',
  address:'Löbauerstr. 36, 02625 Bautzen',
  email: 'info@roseannett.de',
  mobile:'+49 152 22800514',
  vatID:'794 209 65816',
  descriptionInfo: 'Kleinunternehmer/in iSv § 19 UStG',
  detailedExpo:`Ich bin Annett, Kreativkopf, Floristin & Nähmaus.


Meine Passion: 	“aus einem Stück Stoff, mit Liebe & Handwerk - Etwas Einzigartiges zu entfesseln„


In meiner kleinen Nähstube zu Bautzen, bin ich und meine Familie zu Hause. Hier entstehen Allerlei Einzelstücke für Klein & Groß, sowie dekoratives für euer Zuhause.


Die Leidenschaft für das Nähen, durfte ich in einer ABM- Maßnahme 1995 bei einer gelernten Schneiderin von der Pike auf entdecken. Nachdem ich 2009 noch eine Floristen Ausbildung erfolgreich abgeschlossen habe, meine Kinder schon älter waren, habe ich mein Label „roseA“ 2017 ins Leben gerufen.


Die eingestaubte Nähmaschine wurde wieder ins Leben zurückgerufen & die floristischen Kenntnisse mit dem Nähen verbunden, welches ich bis heute zu sehr liebe und meine Kundschaft damit glücklich mache.


Mein Haupttätigkeit als Verkäuferin in einem Drogeriemarkt schätze ich sehr & mein leidenschaftliches Hobby ist dazu der perfekte Ausgleich.


Ganz Besonders freue ich mich, dass ich Euch in der StadtWerkstatt eine kleine feine Auswahl anbieten kann. Gern personalisiere ich auch nach euren Wünschen mit Liebe Einzelstücke, freue mich auf Eure Anfragen.
`,
  paypal:false,
},*/
/*
{index:18,
  id: 'Marit',
  name: "Marit Schütze",
  description: 'Ich bin seit über 13 Jahren leidenschaftliche Künstlerin und fange in meinen Tierporträts die tiefe Verbindung zwischen Mensch und Tier ein.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Marit_Symalla/Vogel.jpg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Marit_Symalla/Portrait_Marit_Symalla.jpg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Marit_Symalla/schwalbeglaskombri.jpg",
  process.env.REACT_APP_PUBLIC_URL +"/Marit_Symalla/hundhandkopf.jpg",
  process.env.REACT_APP_PUBLIC_URL +"/Marit_Symalla/Marit.jpg",
  process.env.REACT_APP_PUBLIC_URL +"/Marit_Symalla/euledezimi.jpg",
  process.env.REACT_APP_PUBLIC_URL +"/Marit_Symalla/bienesohnekom.jpg",
  process.env.REACT_APP_PUBLIC_URL +"/Marit_Symalla/feldhasekombri.jpg"],
  socialLinks: {
    facebook:"https://www.facebook.com/artbymaritsymalla",
    instagram: "https://www.instagram.com/art_by_maritsymalla/",
    website:"https://www.marit-symalla.de/"
  },
  leader:'Art by Marit Symalla',
  address:'Alter Dorfplatz 5, 02692 Doberschau',
  email: ' info@marit-symalla.de',
  mobile:'+49 1749496857',
  vatID:'204/ 272/09114',
  descriptionInfo: 'Kleinunternehmer/in iSv § 19 UStG',
  detailedExpo:`Ich fertige seit über 13 Jahren professionell Tierportraits an. Zu zeichnen und malen fing ich schon in der Kindheit an, in meiner späteren Ausbildungszeit als Gestaltungstechnische Assistentin lernte ich noch einiges über die verschiedenen Stilrichtungen und Designs.


Zu dieser Zeit habe ich auch meine erste Auftragszeichnung für eine Bekannte erstellt. Diesen Moment als Sie das Kunstwerk in Händen hielt, werde ich nie vergessen. Für uns beide war es ein sehr emotionaler Moment. Genau das hat mich bestärkt meine Kunst weiter zu verfolgen. Ich habe über die Jahre an einigen Ausstellungen (Gruppen-, sowie Einzelausstellungen) teilgenommen und mich immer weiter entwickelt.


Zu meiner Kunst:

Meine Kunst hat sich in den letzten Jahren immer weiter verändert. Ich fange mit meinen Werken die Lebendigkeit und die Beziehung zwischen Mensch und Tier mit verschiedenen Materialien aus Acrylfarben, Kaffee, Tinte und Kohle ein. Mit ausdrucksstarken Pinselstrichen und dynamischen Kontrasten erzählen die Kunstwerke eine Geschichte verschiedener Welten. Die figürliche Darstellung bringt eine kraftvolle Emotionalität in jeden Raum, eine Einladung zum Innehalten und zur Reflexion über unsere Beziehung zur Natur.
`,
  paypal:false,
},*//*
{index:18,
  id: 'Melanie',
  name: "Melanie Kloß",
  description: 'Mein Name ist Melanie und ich bin das Gesicht hinter SOAPerlausitz.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Melanie_Kloss/SOAPerlausitz3.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Melanie_Kloss/SOAPerlausitz_portrait.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Melanie_Kloss/SOAPerlausitz.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Melanie_Kloss/SOAPerlausitz5.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Melanie_Kloss/SOAPerlausitz4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Melanie_Kloss/SOAPerlausitz3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Melanie_Kloss/SOAPerlausitz2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Melanie_Kloss/SOAPerlausitz1.jpeg"],
  socialLinks: {
    facebook:"https://www.facebook.com/profile.php?id=61555204623354",
    instagram: "https://www.instagram.com/soaperlausitz/",
    website:"https://www.soaperlausitz.de/"
  },
  leader:'SOAPerlausitz',
  address:'Hauptstraße 14, 02748 Bernstadt',
  email: ' info@soaperlausitz.de',
  mobile:'+49 171/2684894',
  vatID:'DE363607571',
  descriptionInfo: 'Kleinunternehmer/in iSv § 19 UStG',
  detailedExpo:`Die Seifensiederin

Mein Name ist Melanie und ich bin das Gesicht hinter SOAPerlausitz.

Ich habe die 40 bereits überschritten und mir in dem Zuge öfter die Fragen gestellt, was ich bereits sinnvolles in meinem bisherigen Leben geleistet habe und was ich mit der zweiten Hälfte meines Lebens noch sinnvolleres anstellen möchte.

Mehr als 20 Jahre habe ich fernab der Heimat verbracht, was mich jetzt in den glücklichen Umstand versetzt, dass ich jeden Tag doppelt genieße, den ich wieder zu Hause bin! Nein es kann nicht nur Wegzug geben, einige kommen auch wieder zurück. Und da bin ich nun! 

Bereit meinen eigenen Beitrag zu leisten, um meine Umwelt und meine Heimat nachhaltig zu schützen und dabei die Oberlausitz vielleicht ein bisschen bekannter zu machen.

Viele fragen sich sicher wie ich denn überhaupt auf die Idee kam meine eigene Seife herzustellen. Wie ich bereits erwähnte, habe ich meine besten Jahre bereits hinter mir und meine Haut reagiert auf einmal ganz empfindlich auf industriell hergestellte Zusatzstoffe. Ich war ständig am eincremen und kam durch ausprobieren letztendlich zu der Erkenntnis, dass eine Pflege mit Wasser und Naturseife meiner Haut am besten hilft.  Der Verzicht auf industriell hergestellte Duschgels und Flüssigseifen hat mich optisch wahrscheinlich 10 Jahre konserviert :)

Und dazu kommt noch, dass ich mit dem Umstieg auf feste Seifen mal eben 2-3 Flaschen Duschgel pro Seife einspare! Das sind über 30 Plastikflaschen pro Jahr.

Das alles war für mich Grund genug, um den langwierigen Prozess einer unabhängigen Sicherheitsüberprüfung zu durchlaufen und seit 2023 bin ich nun Herrin meiner eigenen kleinen Seifenmanufaktur.

Gern lade ich Sie ein selber auszuprobieren wie gut sich Natur anfühlen kann. Ihre Haut und unsere Umwelt wird es Ihnen danken.`,
  paypal:false,
},*//*
{index:21,
  id: 'Nicolle',
  name: "Nicolle Golloch",
  description: 'Ich heiße Nicolle. Inspiriert von der Natur fertige ich in liebevoller Handarbeit Schmuck, welcher deine Fantasie anregt.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Nicolle_Golloch/Armnband.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Nicolle_Golloch/Portrait_Nicolle_Golloch.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Nicolle_Golloch/Armnband.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicolle_Golloch/gold.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicolle_Golloch/Halskette.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicolle_Golloch/Herzkette.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicolle_Golloch/Holzanhänger.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicolle_Golloch/Meersteine.jpeg"],
  socialLinks: {
    facebook:"https://www.facebook.com/profile.php?id=100084893017003&ref=xav_ig_profile_web",
    instagram: "https://www.instagram.com/modomio22/",
    
  },
  leader:'Inhaberin von Modomio',
  address:'Thomas-Mann-Str. 1, 01877 Bischofswerda',
  email: 'modomio22@gmx.de',
  
  vatID:'204/224/01319',
  descriptionInfo: 'Kleinunternehmer/in iSv § 19 UStG',
  detailedExpo:`Kreativ war ich eigentlich schon immer gern, egal ob beim Malen, Sticken, Häkeln, Basteln.


Vor einiger Zeit hatte ich (sehr spontan bei einer gemütlichen Tasse Kaffee) die Idee, mit Harz zu arbeiten. Ich wollte kleine Naturschätze in Harz gießen. Woher diese Idee kam...keine Ahnung. 
Also richtete ich mir im ehemaligen Kinderzimmer unserer bereits erwachsenen Tochter eine kleine Werkstatt ein. 
Im Garten,  beim Spaziergang mit dem Hund oder beim Wandern finde ich die schönsten Materialien für mein Hobby. Oder Freunde, Bekannte, Familie bringen mir ihre kleinen Naturfundsachen: "Schau mal was ich gefunden habe, brauchst du das?"

Damit fertige ich dann mit viel Liebe zum Detail Schmuck, welcher unsere wunderbare Natur wiederspiegelt.
Die Stadtwerkstatt inspiriert mich: die Idee des Miteinanders, die Art der Präsentation und die Bereitschaft der Künstler in Workshops gern ihr Wissen mit anderen zu teilen.
Ich freue mich sehr ein Teil des Stadtwerkstatt Teams sein zu können. 
`,
  paypal:false,
},*//*
{index:24,
  id: 'Kathrin',
  name: "Kathrin Sturm",
  description: 'Mein Name ist Kathrin und ich töpfere die Keramikweiber, die ihr in der Stadtwerkstatt sehen könnt.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Kathrin_Sturm/Ton.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Kathrin_Sturm/Portrait_Kathrin_Sturm.jpg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Kathrin_Sturm/Ton.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kathrin_Sturm/Figur.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kathrin_Sturm/Tonfigur.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kathrin_Sturm/Spatz.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kathrin_Sturm/Prinzessin.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kathrin_Sturm/Tonvogel.jpeg"],
  socialLinks: {
    facebook:"https://www.facebook.com/kathrin.sturm.503",
    instagram: "https://www.instagram.com/kathrinsturm/",
    website:"https://keramikweib.de/"
  },
  leader:'Inhaberin von Keramikweib',
  address:'Techritzer Str. 1a, 02692 Grubschütz',
  email: 'kathrin@keramikweib.de',
  fon:'+49 3591-301451',
  descriptionInfo: 'Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE288142081',
  detailedExpo:`Beruflich schwinge ich den Pinsel und verschönere mit meinen Mitarbeitern der Malerfirma "Malermeister Sturm" Wände, Böden und Fassaden von Wohnungen und Häusern.
Ich lebe in einem Mehrgenerationenhaushalt im dörflichen Umfeld unserer schönen Stadt Bautzen.
Das Material Ton hat mich seit Jahren gepackt und so töpfere ich Figuren, total aus dem Leben gegriffen, gern auch nach individuellen Vorstellungen meiner Kunden.
Ich bin neu in der Stadtwerkstatt und freue mich auf diese neue und spannende Herausforderung.
`,
  paypal:false,
},*/
/*
{index:27,
  id: 'Alex',
  name: "Alexander Schiebel",
  description: 'Ich bin Alex - der kreativer Kopf und Chef der ersten Bautzener Speiseeis-Manufaktur sowie Hersteller feinster Spirituosen wie Schiebels Absinthe & Liköre.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Alexander_Schiebel/flaschen.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Alexander_Schiebel/Portrait_Alexander_Schiebel.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Alexander_Schiebel/flaschen.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Alexander_Schiebel/glas.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Alexander_Schiebel/bild.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Alexander_Schiebel/absinth.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Alexander_Schiebel/kessel.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Alexander_Schiebel/eierlikör.jpeg"],
  socialLinks: {
    facebook:"https://www.facebook.com/alexander.schiebel.9/",
    instagram: "https://www.instagram.com/eisdealer1974/",
    
  },
  leader:'Inhaber von Schiebels Eis& Torten Manufaktur ',
  address:'Seminarstraße 25, 02625 Bautzen',
  email: 'eisdealer@freenet.de',
  fon:'+49 359140727',
  vatID:'89/420/967/151',
  descriptionInfo: '',
  detailedExpo:`Mein Name ist Alexander Schiebel, und ich bin 50 Jahre alt. Seit fast 25 Jahren habe ich das Glück, als kreativer Kopf und Geschäftsführer der ersten Speiseeismanufaktur in Bautzen zu arbeiten. Zusammen mit meinem engagierten Team betreibe ich zudem die "Schiebels Eis und Torten Manufaktur", besser bekannt als „Eisdealer“, direkt aus Bautzen. Neben unseren beliebten Eis- und Tortenkreationen widme ich mich auch der Kunst des Likörs und bin stolz darauf, als Erfinder des ersten sächsischen Absinthe und Hersteller von Schiebels Absinthe & Liköre bekannt zu sein.


Besonders am Herzen liegt uns die Herstellung von Schiebels Eierlikör, der nach unserem eigenen Hausrezept in liebevoller Handarbeit gefertigt wird. Mit feinsten Zutaten und einem Hauch echter Madagaskar-Vanille gelingt es uns, diesem Likör seinen unverwechselbaren, köstlichen Geschmack zu verleihen. Jede Flasche wird mit Sorgfalt von Hand abgefüllt und verpackt – solange der Vorrat reicht.


Ein Highlight unserer Likörmanufaktur ist der außergewöhnliche Einhornpups Likör, hergestellt auf Basis von Eierlikör und verfeinert mit einem zarten Zitronen-Orangen-Aroma, ganz ohne künstliche Farb- oder Aromastoffe. Ebenso stolz sind wir auf unseren Eiersinthe Likör, eine einzigartige Kombination aus unserem hausgemachten Eierlikör und dem 1. Sächsischen Absinthe, die ein wahres Genusserlebnis bietet.


Ein besonderes Kapitel in unserer Geschichte ist der Schiebel Absinthe No. 4, eine limitierte Ausgabe von nur 116 Flaschen, die aus regional angebautem Wermut und anderen erlesenen Kräutern der Oberlausitz hergestellt wurde. Diese Edition steht für unser Engagement für traditionelle Absinthe-Herstellung und bleibt unser letzter Absinthe, um den Liebhabern dieser außergewöhnlichen Spirituose eine unvergessliche Reise in die Welt des Absinthes zu ermöglichen.


Unsere Philosophie ist klar: Handwerk, Qualität und der Verzicht auf künstliche Zusätze sind die Grundlage all unserer Produkte. Wir laden Sie ein, diese Leidenschaft in jeder unserer Kreationen zu entdecken.
`,
  paypal:false,
},*/
{index:6,
  id: 'Benjamin',
  name: "Benjamin Groß",
  description: 'Ich bin Benjamin, Winzer aus Leidenschaft und Gründer eines jungen Familienunternehmens, das den Weinbau in der Lausitz voranbringt und regionale Weine mit Charakter schafft.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Benjamin_Gross/rebe.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Benjamin_Gross/Portrait_Benjamin_Gross.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/rebe.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/Flasche.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/Benjamin.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/weinauswahl.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/reben.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/reb.jpeg"],
  socialLinks: {
    website:"https://www.weinhausgross.de/",
    facebook:"https://www.facebook.com/weinhaus.gross",
    instagram: "https://www.instagram.com/weinhausgross?igshid=ify924y26j3o",
    
  },
  leader:'Inhaber von Weinhaus GROSS',
  address:'Dresdener Straße 33, 01877 Schmölln-Putzkau',
  email: 'weinhaus-gross@web.de',
  fon:'+49 3594/713896',
  mobile:"+49 157 344 18 116",
  vatID:'204/167/02323',
  descriptionInfo: '',
  detailedExpo:`Wir sind ein junges Familienunternehmen geführt von Benjamin Groß - Winzer aus Leidenschaft.


Unsere Idee besteht darin, Reben in der Lausitz anzubauen und diese anschließend zu vermarkten.  Der erste Erfolg kam mit unseren vier Jahreszeiten, die wir zusammen mit einem befreundeten Winzer, Jonas Korndörfer, von der Traube bis hin zum fertigen Wein produzieren und exklusiv für unser Weinhaus abfüllen lassen. Die ersten Trauben können wir bereits ernten und werden den Weinanbau in Putzkau weiter voranbringen.


Ich selbst mache schon Weinbau, seit ich 17 Jahre bin und habe mich sofort in den Beruf verliebt. Es ist und bleibt, für mich eine Faszination wie viele unterschiedliche Facetten ein Wein haben kann. Meine Ausbildung zum Winzer absolvierte ich in Freiburg im Breisgau und nach mehreren Stationen, in einigen anderen Weingüter und Sektkellereien, bin ich seit ca. 4 Jahren wieder in der Heimat. Meine Wurzeln sind hier und ich wollte schon immer den Weinbau hier etablieren, deshalb habe ich vor ca. 10 Jahren damit begonnen die ersten Reben zu pflanzen. 


Jedes Jahr ist für uns eine neue Herausforderung, aber ich bin sehr froh, wenn jemand unsere Passion mit uns teilt. Gerade in der Stadtwerkstatt, sieht man, wenn Kunst und Wein aufeinandertreffen und man damit zeigen kann, was alles in unserer Region machbar ist. 

`,
  paypal:false,
},/*
{index:30,
  id: 'Dienemann',
  name: "Dienemann",
  description: 'Mein bürgerlicher Name ist Albrecht Heindel. Ich dichte, schreibe und trage meine Texte auf Bühnen vor.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Arbrecht_Heindel/EinLandHand.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Arbrecht_Heindel/Portrait_Arbrecht_Heindel.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Arbrecht_Heindel/DM-Signatur.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Arbrecht_Heindel/DerMund.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Arbrecht_Heindel/Dienemann.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Arbrecht_Heindel/A6Druck.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Arbrecht_Heindel/Halle.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Arbrecht_Heindel/Jahreszeitfern.jpeg"],
  socialLinks: {
    website:"https://www.dienemann.online/",
 
    
  },
  leader:'Albrecht Heindel Inhaber von Dienemann Jazz-Poesie',
  address:'Niederkainaer Straße 1, 02625 Bautzen',
  email: 'info@dienemann.online',
  fon:'+49 1556 1267476',
  
  descriptionInfo: 'Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE369294477',
  detailedExpo:`Mein bürgerlicher Name ist Albrecht Heindel. Ich dichte, schreibe und trage meine Texte auf Bühnen vor. Ich komme aus, lebe und arbeite in Bautzen.


Die deutsche Sprache und das, was man aus ihr machen kann, ist meine Inspiration. Ich suche in der Dichtung das Geheimnis. Ich bin mit einem Text erst dann zufrieden, wenn er mehr weiß, als ich selbst. Ich schreibe schon mein Leben lang, habe aber erst jetzt beschlossen, meine Kunst in´s Zentrum meines Lebens zu stellen.




Im Sommer 2024 erblickte „Dienemann“ das Licht der Welt. Ihm lege ich die Wort in den Mund. Er wird sie auf Bühnen vortragen. Und er verwandelt sie in kalligrafische Kunstwerke, die in Wohn- und Geschäftsräumen ihre Ausstrahlung entfalten können. Rhythmus und Taktgefühl sind uns beiden wichtig, deshalb bezeichne ich meine Kunst als Jazz-Poesie.




Früher – in den Zeiten meiner Großeltern - war es üblich, das in Wohnungen Gedichte, Sinn- und Segenssprüche an die Wänden hing. Diese Tradition greife ich auf und interpretiere sie neu. Meine Drucke und Handschriften laden ein zum Innehalten und erwecken poetische Momente.

 
`,
  paypal:false,
},*/
{index:54,
  id: 'Corinna',
  name: "Corinna Fischer",
  description: '',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Benjamin_Gross/rebsfe.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Portrait_Corinna_Fischer.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/rebsfge.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/Flaschsfe.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/Benjsfamin.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/weinfsauswahl.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/refsben.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/refsb.jpeg"],
  socialLinks: {
   website:'https://www.corinnafischer.com/'
    
  },
  leader:'Anbieterin von eigener Naturkosmetik',
  address:'Lange Gasse 33, 02739 Kottmar OT Walddorf',
  email: 'fischer.corinna15@gmail.com',
  fon:'+49 3586 707 38 38',
  
  descriptionInfo: 'EXTERN',
  detailedExpo:`
`,
  paypal:false,
},
{index:9,
  id: 'Elisa',
  name: "Elisa Schmidt",
  description: ' Ich bin Elisa - Immobiliengutachterin, Immobilienberaterin, Autorin und Unternehmerin aus der Oberlausitz.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Elisa_Schmidt/Elisa_Schmidt3.png',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Elisa_Schmidt/Elisa_Schmidt.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Elisa_Schmidt/Elisa_Schmidt1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Elisa_Schmidt/Elisa_Schmidt2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Elisa_Schmidt/Elisa_Schmidt3.png",
  process.env.REACT_APP_PUBLIC_URL +"/Elisa_Schmidt/Elisa_Schmidt4.png",
  process.env.REACT_APP_PUBLIC_URL +"/Elisa_Schmidt/Elisa_Schmidt5.png",
  process.env.REACT_APP_PUBLIC_URL +"/Elisa_Schmidt/Elisa_Schmidt6.png"],
  socialLinks: {
   instagram:'https://www.instagram.com/gutachtenlausitz/',
   website:'https://www.corinnafischer.com/'
    
  },
  leader:'Gutachten Lausitz',
  address:'Straße des Friedens 14, 02708 Dürrhennersdorf ',
  email: 'mail@gutachtenlausitz.de',
 
  vatID:' 208/269/00394',
  descriptionInfo: 'Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE358453836',
  detailedExpo:`
 Ich bin Immobiliengutachterin, Immobilienberaterin, Autorin und Unternehmerin aus der Oberlausitz. Beruflich beschäftige ich mich mit Immobilien, Grundstücken, Bewertungen und den Entscheidungen, die damit verbunden sind. Mich interessieren komplexe Themen, klare Strukturen und die Frage, was hinter Zahlen, Orten und Möglichkeiten wirklich steckt.




Gleichzeitig bin ich selbst neurodivergent. Neurodivergenz prägt meinen Blick auf Arbeit, Alltag, Lernen und Unternehmertum. Ich weiß aus eigener Erfahrung, wie anstrengend es sein kann, wenn Informationen zu kompliziert, Erwartungen unausgesprochen oder Hilfen nicht wirklich alltagstauglich sind. Deshalb ist es mir wichtig, Angebote zu entwickeln, die niedrigschwellig, verständlich und praktisch sind – ohne zu belehren, zu überfordern oder Menschen in Schubladen zu stecken.




Daraus entstehen bei mir unterschiedliche Projekte: Bücher, kreative Produkte, Workshops, Markenideen und alltagstaugliche Hilfen. Dazu gehört unter anderem das MiniHeft. Es soll dabei unterstützen, Dinge einfacher zu sortieren, Gedanken festzuhalten und im Alltag einen greifbaren Zugang zu finden. Auch die Idee hochwertiger Streetwear gehört dazu: Kleidung, die nicht beliebig ist, sondern Design, Identität und Haltung miteinander verbindet.




Ich bewege mich gern zwischen Immobilienwirtschaft, Schreiben, Kreativität und Unternehmertum. Vermutlich auch deshalb, weil ich mich nie auf nur eine Sache beschränken konnte. Ich bin überzeugt, dass gerade an diesen Schnittstellen neue Ideen entstehen können – Ideen, die nicht nur gut aussehen oder gut klingen, sondern im Alltag tatsächlich etwas erleichtern oder Menschen ermutigen.




Mit der Stadtwerkstatt verbindet mich die Freude an Menschen, die etwas ausprobieren, gestalten und aufbauen wollen. Ich mag Orte, an denen unterschiedliche Perspektiven nicht glattgebügelt werden müssen, sondern als Stärke gesehen werden. Für mich ist die Stadtwerkstatt ein Raum für Austausch, für mutige Ideen und für Projekte, die zeigen: Es gibt viele Wege, zu lernen, zu arbeiten, kreativ zu sein und erfolgreich zu sein.
`,
  paypal:false,
},
{index:59,
  id: 'Ulrike',
  name: "Ulrike Brömel",
  description: '',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Benjamin_Gross/rebsfe.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Workshop/portraitulrike.png',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/rebsfge.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/Flaschsfe.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/Benjsfamin.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/weinfsauswahl.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/refsben.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/refsb.jpeg"],
  socialLinks: {
   website:'https://natuerlich-oele.de/'
    
  },
  leader:'Anbieterin von natürlichen Ölen',
  address:'Tetschener Str. 27, 01277 Dresden',
  email: 'fulrike@natuerlich-oele.de',
  fon:'+49 1525 6173726',
  
  descriptionInfo: 'EXTERN',
  detailedExpo:`
`,
  paypal:false,
},
/*
{index:12,
  id: 'Nicole Tischer',
  name: "Nicole Tischer",
  description: 'Hallo, ich bin Nicole und erschaffe Kunst voller Freude, Lebendigkeit und stiller Kraft.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Nicole_Tischer/Tischer6.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Nicole_Tischer/tischer123.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Nicole_Tischer/Tischer1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicole_Tischer/Tischer2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicole_Tischer/Tischer4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicole_Tischer/Tischer5.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicole_Tischer/Tischer6.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicole_Tischer/tischer3.png"],
  socialLinks: {
   website:'https://nicole-tischer.de',
  instagram: "https://www.instagram.com/atelier_nicole_tischer/", 
  },
  leader:'Inhaber Brauhaus Scheune am See',
  address:'Mühlenstr. 3, 01945 Ruhland',
  email: 'kontakt@nicole-tischer.de',
  fon:'+49 176 36 333 455',
  vatID: 'Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE350783305',
  descriptionInfo: 'Atelier Nicole Tischer',
  detailedExpo:`
  Hallo, ich bin Nicole und erschaffe Kunst voller Freude, Lebendigkeit und stiller Kraft.


  Meine Arbeiten verbinden Farbe und Form zu ausdrucksstarken Kompositionen, die zwischen Energie und Ruhe balancieren. So entstehen Werke, die eine lebendige, kreative Ausstrahlung besitzen und zugleich Raum für Stille, Kraft und Reflexion schaffen.


Ich arbeite als Mixed-Media-Künstlerin mit verschiedenen Materialien auf Papier und Holz im kleinen Format. Charakteristisch für meine Kunst ist eine moderne, dynamische Bildsprache mit einer klaren, wiedererkennbaren Handschrift.
Meine Werke entstehen aus dem Moment heraus – intuitiv und ohne feste Vorgaben. Jedes einzelne entwickelt dabei seine eigene, unverwechselbare Ausstrahlung und eröffnet vielfältige Interpretationsräume.


Erlebe meine Kunst ganz in Ruhe und in einem wunderschönen Ambiente in deiner Stadtwerkstatt.
`,
  paypal:false,
},*/
{index:38,
  id: 'Nicole',
  name: "Nicole Otzowsky",
  description: 'Hallo, ich bin Nicole – der kreative Kopf hinter KleGro. ',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Nicole/Nicole1.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Nicole/Nicole2.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Nicole/Nicole3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicole/Nicole1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicole/Nicole4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicole/Nicole5.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicole/Nicole1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nicole/Nicole4.jpeg"],
  socialLinks: {
   
  },
  leader:'Klegro',
  address:'Jägerweg 15a, 01454 Wachau',
  email: 'NicoleOtzowsky@googlemail.com',
  mobile:'+49 163 8715630',
  vatID: '49 027 839 565',
  descriptionInfo: '',
  detailedExpo:`
  Hallo, ich bin Nicole – der kreative Kopf hinter KleGro. 




Nähen ist für mich viel mehr als Stoff, Garn und eine Nähmaschine. Ich liebe es, aus schönen Materialien mit viel Sorgfalt und Herz besondere Einzelstücke entstehen zu lassen.




Bei KleGro – Handarbeit aus Ostsachsen fertige ich liebevoll genähte Lieblingsstücke für Groß und Klein. Dabei ist mir wichtig, dass meine Sachen praktisch sind, Freude machen und gleichzeitig etwas Persönliches haben.




Am schönsten finde ich den Moment, wenn aus einer Idee Schritt für Schritt etwas entsteht, das später einen Menschen begleitet oder verschenkt wird. Genau das macht für mich Handarbeit so besonders.




Mit Liebe ausgesucht. Mit Freude genäht. Von Hand gemacht.
Eure Nicole
`,
  paypal:false,
},
{index:51,
  id: 'Dominic',
  name: "Dominic Schiller",
  description: '',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Benjamin_Gross/rebsfe.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Workshop/profilbilddominic.png',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/rebsfge.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/Flaschsfe.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/Benjsfamin.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/weinfsauswahl.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/refsben.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Benjamin_Gross/refsb.jpeg"],
  socialLinks: {
   website:'https://www.wohntraeume-schiller.com/',
     },
  leader:'Wohn(t)räume mit Dominic Schiller',
  address:'Blösaer Straße 2d, 02627 Kubschütz',
  email: 'info@wohntraeume-schiller.de',
  mobile:'+49 176 41566121',
  vatID: '',
  descriptionInfo: 'EXTERN',
  detailedExpo:`
`,
  paypal:false,
},
{index:15,
  id: 'ProBier-Werkstatt',
  name: "Maik Richter",
  description: 'Das sind Wir – ProBier – „ProBier’s – du wirst es schmecken!',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/ProBier/probier.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/ProBier/probier_portrait.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/ProBier/probier1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/ProBier/probier2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/ProBier/probier3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/ProBier/probier4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/ProBier/probier.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/ProBier/probier5.jpeg"],
  socialLinks: {
   website:'https://www.probier-werkstatt.de/',
   facebook:"https://www.facebook.com/nicole.kocksch",
   instagram: "https://www.instagram.com/cunewalder_probier_werkstatt/", 
     },
  leader:'Cunewalder ProBier-Werkstatt GmbH',
  address:'Hauptstraße 76, 02733 Cunewalde',
  email: 'post@probier-werkstatt.de',
  fon:'+49 35877 886400',
  mobile:'+49 173 7686642',
  vatID: '',
  descriptionInfo: 'Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:DE815892775, Handelsregister Dresden: HRB40745',
  detailedExpo:`
  Das sind Wir – ProBier

Unsere Biere brauen wir mit Liebe und Freude in traditioneller Handwerkskunst. Dabei legen wir großen Wert auf regionale Zutaten. Da die Biere weder pasteurisiert noch gefiltert werden und ausreichend Zeit zur Reifung bekommen, entfalten sie den vollen natürlichen Geschmack. So entstehen in unserer ProBier Werkstatt großartige Biere, die einzigartig und reich an Aromen sind. Frisch und lebendig wie die Natur. Das wollen wir den Bierliebhabern wieder näherbringen, hin zum bewussten Genuss – „ProBier’s – du wirst es schmecken!“
`,
  paypal:false,
},
{index:18,
  id: 'Anett',
  name: "Anett Pötschke ",
  description: 'Mein Name ist Anett Pöschke. Inmitten des hektischen Alltags, den unser Beruf als Augenoptikermeisterin mit sich bringt, habe ich ein beruhigendes Hobby gefunden, das meine Leidenschaft für Asthetik und Entspannung vereint.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Anett_Poetschke/lichterwerkstatt5.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Anett_Poetschke/lichterwerkstatt_portrait.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Anett_Poetschke/lichterwerkstatt.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Anett_Poetschke/lichterwerkstatt1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Anett_Poetschke/lichterwerkstatt2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Anett_Poetschke/lichterwerkstatt3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Anett_Poetschke/lichterwerkstatt4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Anett_Poetschke/lichterwerkstatt5.jpeg"],
  socialLinks: {
    website:'http://www.die-sehfahrer.de/',
   instagram: "https://www.instagram.com/lichterwerkstatt2025/", 
     },
  leader:'Lichterwerkstatt',
  address:'Hermsdorfer Str. 16a, 02699 Königswartha',
  email: 'Sehfahrer@freenet.de',
  
  vatID: '294 967 976',
  descriptionInfo: 'Kleinunternehmer/in iSv § 19 UStG',
  detailedExpo:`
  Mein Name ist Anett Pöschke.

Inmitten des hektischen Alltags, den unser Beruf als Augenoptikermeisterin mit sich bringt, habe ich ein beruhigendes Hobby gefunden, das meine Leidenschaft für Asthetik und Entspannung vereint.

Umgeben von der liebevollen Kunstfertigkeit und dem präzisen Umgang mit den Augen, wollte ich etwas schaffen, das sowohl meine kreative Seite anspricht als auch für innere Ruhe sorgt

Ich liebe die Schönheit von Blumen und den beruhigenden Schein von Kerzen . Diese beiden zeitlosen Elemente kommen in meinen individuell gestalteten Blumen-Kerzensträußen zusammen und bieten eine wundervolle Möglichkeit, sowohl das Herz als auch das Zuhause zu erfreuen.

Jeder Strauß wird mit viel Liebe und Sorgfalt kreiert, um ein harmonisches Zusammenspiel von Farben und Düften zu gewährleisten.

Für jeden Anlass und jeden Raum Egal, ob für eine festliche Gelegenheit, ein entspannendes Abendessen oder einfach zur eigenen Verschönerung Ihres Zuhauses - meine Blumen-Kerzensträuße sind die perfekte Wahl! Sie bringen nicht nur Farbe und Licht in Ihr Leben, sondern schaffen auch eine einladende Atmosphäre, die zum Verweilen einlädt.

Stellen Sie sich vor: Ein wunderschöner Strauß, umgeben von dem sanften Licht brennender Kerzen, der die Sinne betört und eine friedliche Stimmung verbreitet.



Individuelle Anpassung für persönliche Akzente

Ich biete eine Vielzahl von Blumen, von zarten Rosen bis hin zu leuchtenden Sonnenblumen, und kombiniere sie mit verschiedenen Kerzenarten und -düften, die perfekt zu Ihrem Stil passen. Lassen Sie Ihrer Kreativität freien Lauf! Ob Sie eine besondere Farbe oder einen bestimmten Duftrichtungswunsch haben, ich freue mich darauf, Ihre Wünsche umzusetzen und etwas Einzigartiges zu schaffen.

Lassen sie sich von Blumen und dem Licht der Kerzen verzaubern!

Kommen Sie vorbei und entdecken Sie, wie meine Kreationen Ihre Sinne erfreuen.
`,
  paypal:false,
},
{index:21,
  id: 'Robert',
  name: "Robert Czyzowski",
  description: 'Meine Name ist Robert Czyzowski und in der Oberlausitz besser bekannt unter meinem Label „HONIGSTAUB".',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Robert_Czyzowski/honigstaub5.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Robert_Czyzowski/honigstaub_portrait.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Robert_Czyzowski/honigstaub.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Robert_Czyzowski/honigstaub5.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Robert_Czyzowski/honigstaub4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Robert_Czyzowski/honigstaub3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Robert_Czyzowski/honigstaub2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Robert_Czyzowski/honigstaub1.jpeg"],
  socialLinks: {
   website:'https://www.honigstaub.de/',
     instagram: "https://www.instagram.com/honigstaub.de/", 
     },
  leader:'Apoidea Handels GmbH',
  address:'Spreegasse 10, 02625 Bautzen',
  email: 'mail@honigstaub.de',
  fon:'+49 3591/671050',
  
  vatID: '204/105/04392',
  descriptionInfo: 'Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:USt-ID: DE332831227, Handelsregister Dresden: HRB 40316',
  detailedExpo:`
  DMeine Name ist Robert Czyzowski und in der Oberlausitz besser bekannt unter meinem Label „HONIGSTAUB".


Honig küsst Gin! Unser Honigstaub Premium Gin wird aus erlesenen Botanicals gebrannt und mit einem Hauch Honig verfeinert.

Dieser in Sachsen handgebrannte und destillierte Gin schmeckt samtig weich.

Der Honig wirkt als Geschmacksverlängerer und rundet die erlesenen Botanicals alo.

Somit kann Honigstaub Honig Gin sowohl pur wie auf Eis und gemixt mit Tonic genossen werden.

Die 50cl Flasche kommt in einer hochwertigen Geschenkverpackung •

Eine super Geschenkidee für jeden Gin- und Honigfreund.


Honig küsst Whisky! Hochwertiger Whisky aus der Sächsischen Spirituosenmanufaktur trifft auf feinsten regionalen Honig -

Es entsteht ein Whisky Honig Likör mit Vanille samtig weich mit einer angenehmen Süße.

Die 50cl Flasche kommt in einer hochwertigen Geschenkverpackung.

Eine super Geschenkidee für jeden Whisky- und Honigfreund.


GLÜHGIN HANDGEMACHT IN SACHSEN - Hochwertiger exklusiver Gin aus der Sächsischen Spirituosenmanufaktur trifft auf feinsten regionalen Honig & erlesene Zutaten - Perfekt für besondere Genussmomente an kalten Wintertagen.

Ob zu Weihnachten oder zu einem anderen besonderen Anlass - dieser edle Glüh Gin aus Deutschland ist das perfekte Präsent für Liebhaber außergewöhnlicher

Genussmomente.

ERLESENE ZUTATEN - Apfelwein, Gin, Honig, Aroniasaft, Wacholder, Zitronenschale, Orangenschale, Zimt, Sternanis und Gewürznelke


HONIGSTAUB HONIG-GIN EIERLIKÖR

Einzigartige Geschmackskomposition - Feinster Honig und edler Gin verschmelzen zu einem cremigen Eierlikör und machen ihn zu einem unvergleichlichen Genusserlebnis.
`,
  paypal:false,
},
{index:33,
  id: 'Isabel',
  name: "Isabel Peschel",
  description: 'Mein Name ist Isabel Peschel und ich genieße ich meine kreative Auszeit mit Naturmaterialien, Gießpulver und meinen 3D Drucker',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Isabel/Isabel1.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Isabel/Isabel2.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Isabel/Isabel3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Isabel/Isabel1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Isabel/Isabel4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Isabel/Isabel5.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Isabel/Isabel6.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Isabel/Isabel7.jpeg"],
  socialLinks: {
  
   
   instagram: "https://www.instagram.com/peschelisabel/", 
     },
  leader:'Inh. Dies&Das Geschenke mit Herz ',
  address:'Siedlerstraße 13, 01904 Ringenhain',
  
  mobile:'+49 1520 6414353',
  email:'info@stadtwerkstatt-bautzen.de',
  vatID: '204/256/03559',
  descriptionInfo: 'Kleinunternehmer/in iSv § 19 UStG',
  detailedExpo:`
Mein Name ist Isabel Peschel und ich wohne gemeinsam mit meiner Familie in der wunderschönen Oberlausitz. Schon als Kind war ich voller kreativer Ideen und konnte mich stundenlang mit Stiften, Schere und Papier beschäftigen. Irgendetwas zu gestalten, auszuprobieren oder mit den eigenen Händen entstehen zu lassen, hat mich schon immer begeistert.




Auch heute ist die Kreativität ein wichtiger Teil meines Lebens. In meiner kleinen kreativen Auszeit kann ich abschalten, neue Ideen ausprobieren und einfach mal den Alltag für einen Moment vergessen. Dabei liebe ich es, mit den unterschiedlichsten Materialien zu experimentieren – von Naturmaterialien über Gießpulver bis hin zu meinem 3D-Drucker. Besonders schön finde ich es, wenn aus einer einfachen Idee Schritt für Schritt etwas ganz Besonderes entsteht.




Für mich bedeutet Kreativität nicht, immer perfekt sein zu müssen. Viel wichtiger ist mir die Freude am Ausprobieren, am Selbermachen und daran, immer wieder etwas Neues zu entdecken. Manchmal entsteht dabei genau das, was ich mir vorgestellt habe – und manchmal etwas völlig anderes. Aber genau das macht für mich den Reiz aus.




Meine kreative Auszeit ist für mich die schönste Art, meine Zeit „sinnvoll“ zu verschwenden – mit ganz viel Herz, Freude und ohne es jemals zu bereuen! ❤️




Denn am Ende zählt für mich nicht nur das fertige Ergebnis, sondern vor allem die Zeit, die ich beim Kreativsein genießen durfte.
`,
  paypal:false,
},
{index:24,
  id: 'Monique',
  name: "Monique Seibt",
  description: 'Ich bin Monique Seibt, Inhaberin einer Gartenbaufirma – und im Herzen schon immer eine Bastlerin.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Monique_Seibt/mo1.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Monique_Seibt/mo11.jpeg',
  images: [ process.env.REACT_APP_PUBLIC_URL +"/Monique_Seibt/mo1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Monique_Seibt/mo2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Monique_Seibt/mo3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Monique_Seibt/mo4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Monique_Seibt/mo5.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Monique_Seibt/mo6.jpeg"],
  socialLinks: {
   

   instagram: "https://www.instagram.com/mo._s/", 
     },
  leader:"Inhaber von Mo'S",
  address:'Arnsdorfer Str 4 02692 Obergurig ',
  email: 'MoS-holz@gmx.de',
  
  mobile:'+49 15787003313',
  vatID: ' 204/274/02224',
  descriptionInfo: 'Kleinunternehmer/in iSv § 19 UStG',
  detailedExpo:`
  Ich bin Monique Seibt, Inhaberin einer Gartenbaufirma – und im Herzen schon immer eine Bastlerin. Als Kind habe ich liebend gern die Werkstatt meines Opas durcheinandergebracht, genagelt, geschraubt und Dinge ausprobiert, einfach aus Neugier und Freude am Tun.


  Heute ist das Werkeln mein Ausgleich zum oft stressigen Firmenalltag. In der Werkstatt „zum Holzwurm“ entstehen mit viel Liebe zum Detail handgemachte Dekorationen aus Holz. Dort kann ich abschalten, kreativ sein und Neues erschaffen.


  Besonders am Herzen liegt mir das Miteinander, deshalb arbeite ich eng mit der stattwerkstatt zusammen. Für mich bedeutet Handwerk nicht nur Arbeiten mit den Händen, sondern auch Austausch, Gemeinschaft und Freude am gemeinsamen Schaffen.
`,
  paypal:false,
},
{   index:27,
  id: 'Wiola ',
  name: "Wioleta Marynicz-Hoch",
  description: 'Ich bin Wiola – Keramikkünstlerin mit Leidenschaft für handgefertigte Unikate und kreative Workshops, in denen Menschen ihre eigene Kreativität entdecken können.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Wiola/Wiola1.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Wiola/Wiola2.jpeg',
  images: [process.env.REACT_APP_PUBLIC_URL +"/Wiola/Wiola3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Wiola/Wiola1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Wiola/Wiola4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Wiola/Wiola5.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Wiola/Wiola6.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Wiola/Wiola7.jpeg"],
  socialLinks: {
    website: "https://arteoybin.com/",
    instagram: "https://www.instagram.com/arte.atelier.oybin/",
  },
leader:'Arte Oybin',
address:'Hauptstraße 28, 02797 Kurort Oybin',
mobile:'+49 35844 20 48 03',
email: 'info@arteoybin.com',

vatID:'DE330372026',
descriptionInfo: 'Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz',
detailedExpo:`
Mein Name ist Wiola und ich bin Keramikkünstlerin aus Leidenschaft. In meinem Atelier entstehen handgefertigte Keramikstücke, die Natürlichkeit, Funktionalität und liebevolle Details miteinander verbinden. Besonders wichtig ist mir, dass jedes Stück ein Unikat ist und mit viel Sorgfalt und Herz gefertigt wird.
Die Liebe zum kreativen Arbeiten begleitet mich schon seit vielen Jahren. Aus einem Hobby wurde Schritt für Schritt eine Berufung. Heute gestalte ich nicht nur Keramik, sondern gebe meine Begeisterung auch in Workshops weiter. Es macht mir große Freude zu sehen, wie Menschen beim Arbeiten mit Ton zur Ruhe kommen, Neues ausprobieren und stolz ihre eigenen Werke mit nach Hause nehmen.



Mit der Stadtwerkstatt verbindet mich die gemeinsame Idee, Kreativität, Handwerk und Begegnung zu fördern. Solche Orte schaffen Raum für Austausch, Inspiration und gemeinsames Gestalten – Werte, die mir persönlich sehr am Herzen liegen. Deshalb freue ich mich, Teil dieses kreativen Netzwerks zu sein und meine Leidenschaft für Keramik mit anderen Menschen teilen zu können.

`,
paypal:false,
},
{   index:30,
  id: 'Kati & Mario',
  name: "Kati Schmidt",
  description: 'Ka-Ma Home Design - Zeitlose Unikate aus Kaltporzellan für dein Zuhause',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Kati_Schmidt/kama.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Kati_Schmidt/kama_portrait.jpeg',
  images: [process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/kama.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/kama1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/kama2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/kama3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/kama4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/kama5.jpeg"],
  socialLinks: {
    instagram: "https://www.instagram.com/kamahomedesign/",
    facebook: "https://www.facebook.com/profile.php?id=100073333073365&ref=xav_ig_profile_web",
    website: "https://stadtwerkstatt-bautzen.de",
  },
leader:'Ka-Ma Home Design',
address:'Blumenstraße 31, 02692 Doberschau',
email: 'meinert.kati@freenet.de',
mobile: '+49 176 50494712',
fon:'+49 3591 272668',
vatID:'204 269 02711',
descriptionInfo: 'Kleinunternehmerin iSv § 19 UStG',
detailedExpo:`Zeitlose Unikate aus Kaltporzellan für dein Zuhause


Jedes Stück erzählt eine Geschichte und bringt einen Hauch von Eleganz und Individualität in deine vier
Wände.


Kreative Vielfalt und Handwerkskunst.
Die Leidenschaft für das Handwerk spiegelt sich in jedem Detail der Unikate wider. Kaltporzellan ist nicht nur ein vielseitiges Material, sondern auch ideal für die Schaffung von zeitlosen Dekorationselementen.


Von filigranen und stilvollen Skulpturen bis hin zu eleganten Wohnaccessoires, die aktuelle Kollektion bietet eine Vielzahl von Möglichkeiten, um deiner Einrichtung eine persönliche Note zu verleihen.`,
paypal:false,
},
{   index:36,
  id: 'Nico',
  name: "Nico Froehlich",
  description: 'Ich bin Nico Froehlich – mein Name ist jeden Tag Programm.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Nico_Froehlich/Nico_Froehlich7.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Nico_Froehlich/Nico_Froehlich6.jpeg',
  images: [process.env.REACT_APP_PUBLIC_URL +"/Nico_Froehlich/nico1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nico_Froehlich/nico2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nico_Froehlich/nico3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nico_Froehlich/nico4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nico_Froehlich/nico5.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Nico_Froehlich/Nico_Froehlich4.jpeg"],
  socialLinks: {
    instagram: "https://www.instagram.com/derfilmdeineslebens/",
    website: "https://www.froesi-balanceplus.com/",
  },
leader:'Nico Froehlich',
address:'Friedrich-Engels-Straße 13, 02692 Doberschau',
email: 'froesi27@hotmail.com',
mobile:'+49 151 25554806',
vatID:'204 220 05669',
descriptionInfo: '',
detailedExpo:`Ich bin Nico Froehlich – mein Name ist jeden Tag Programm. Mit meinem Buch „Der Film deines Lebens“ lade ich Menschen dazu ein, wieder näher zu sich selbst zu finden und die Hauptrolle in ihrem eigenen Leben bewusst zu übernehmen.


Zu meiner Berufung gehören die wertvolle pädagogische Arbeit mit Kindern, meine Tätigkeit als Achtsamkeitstrainer zur Stressbewältigung und seit Neuestem darf ich mich nun auch Buchautor nennen.


Meine persönliche Lebensgeschichte, die daraus gewonnenen Erkenntnisse sowie meine bewusste Einstellung zum Leben haben mich dazu animiert, Achtsamkeit nicht nur zu leben, sondern auch weiterzugeben. Vor allem an Menschen, die sie vergessen oder vielleicht sogar verloren haben.


In meinem tiefgründigen und zugleich greifbaren Buch nehme ich dich mit auf eine besondere Reise zu dir selbst. Mithilfe der kraftvollen Metapher eines Films öffne ich neue Perspektiven auf Themen wie Selbstfindung, Glaubenssätze, Beziehungen, Emotionen, gesellschaftliche Rollen, Spiritualität, innere Heilung sowie Bewusstsein und Seele.


Kapitel für Kapitel erkennst du, welche Rollen du übernommen hast, welche Masken du trägst und welche „Kulissen“ dein Leben bestimmen. Du lernst, deinen größten Kritiker kennenzulernen und zu verstehen, deinen Fokus neu auszurichten und bewusster auf die Stimme deines Herzens zuhören.


Dieses Buch ist keine klassische Lebensanleitung. Es ist eine Einladung, dich selbst ehrlich zu betrachten und deinem eigenen Wesen wieder näherzukommen.


Ein Buch für Menschen, die mehr Tiefe im Leben suchen, sich innerlich weiterentwickeln möchten und bereit sind, sich selbst neu zu begegnen.


Denn am Ende bleibt nur eine Frage:


Welchen Film willst DU leben?
`,
paypal:false,
},
{   index:39,
  id: 'Susanne',
  name: "Susanne Anders",
  description: 'Susanne ist die Gründerin von Spreefunke und lässt aus der Inspiration ihrer Kinder sowie der Verbundenheit zur Oberlausitz besondere Produkte entstehen',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Susanne_Anders/Susanne_Anders1.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Susanne_Anders/Susanne_Anders5.jpeg',
  images: [process.env.REACT_APP_PUBLIC_URL +"/Susanne_Anders/Susanne_Anders2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Susanne_Anders/Susanne_Anders3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Susanne_Anders/Susanne_Anders4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Susanne_Anders/anders12.png",
  process.env.REACT_APP_PUBLIC_URL +"/Susanne_Anders/anders13.png",
  process.env.REACT_APP_PUBLIC_URL +"/Susanne_Anders/Susanne_Anders1.jpeg"],
  socialLinks: {
    instagram: "https://www.instagram.com/spreefunke/",
       website: "https://spreefunke.de/",
  },
leader:'Spreefunke',
address:'Blumenstraße 31, 02692 Doberschau',
email: 'info@spreefunke.de',
fon:'+49 3591 5950672',
vatID:'',
descriptionInfo: '',
detailedExpo:`
Susanne Anders ist die kreative Gründerin von Spreefunke und lässt aus der Inspiration ihrer Kinder sowie der Verbundenheit zur Oberlausitz besondere Produkte entstehen – von liebevollen Illustrationen bis hin zu individuellen Lasergravuren.




Mich begeistert der Moment, wenn aus einer kleinen Idee etwas entsteht, das man anfassen, verschenken oder erleben kann. Oft beginnt alles mit einem Gedanken, einer Skizze oder einer spontanen Inspiration. Daraus werden mit Leidenschaft und den passenden Werkzeugen einzigartige Produkte.




Besonders fasziniert mich die Verbindung von Kreativität und Technik. Mit Grafikprogrammen, Plotter und Laser verwandle ich Ideen in greifbare Ergebnisse – von individuellen Geschenkideen über kreative Dekorationen bis hin zu eigenen Projekten. Dabei probiere ich gerne Neues aus und entwickle bestehende Ideen immer weiter.




Ich bin überzeugt, dass in den kleinen Dingen oft das größte Potenzial steckt. Genau deshalb liebe ich es, Möglichkeiten zu entdecken, Details zu verfeinern und aus etwas Unscheinbarem etwas Besonderes entstehen zu lassen. Kreativität bedeutet für mich nicht nur Gestalten, sondern vor allem Neugier, Ausprobieren und den Mut, neue Wege zu gehen.
`,
paypal:false,
},
{   index:42,
  id: 'Steffen',
  name: "Steffen Nowack",
  description: 'Ich bin Steffen Nowack, Bioenergetiker mit Leib und Seele, Menschen-Stärker und seit letztem Jahr auch Buchautor.',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Steffen_Nowack/steffen5.jpeg',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Steffen_Nowack/steffenpb.jpeg',
  images: [process.env.REACT_APP_PUBLIC_URL +"/Steffen_Nowack/steffen2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Steffen_Nowack/steffen3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Steffen_Nowack/steffen4.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Steffen_Nowack/steffen5.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Steffen_Nowack/steffen6.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Steffen_Nowack/steffen1.jpeg"],
  socialLinks: {
    instagram: "https://www.instagram.com/steffen_nowack/",
    facebook:'https://www.facebook.com/share/19H38vPTy3/?mibextid=wwXIfr',
       website: "https://steffennowack.de/",
  },
leader:'Voller Kraft und Energie',
address:'Schafbergstraße 4, 02625 Bautzen',
email: 'steffennowack@gmx.info',
mobile:'+49 176 53129736',
vatID:'',
descriptionInfo: '',
detailedExpo:`
Hallo, ich bin Steffen Nowack,



Bioenergetiker mit Leib und Seele, Menschen-Stärker und seit letztem Jahr auch Buchautor.


Ich habe 2017 einen sehr ungewöhnlichen Schritt gewagt und meinen hochbezahlten Führungs-Job in der Baubranche aufgegeben, um meine wahre Berufung zu leben.



Seitdem stärke und begleite ich sowohl in meinem Stärkungszentrum in Bautzen, als auch online täglich Menschen in gesundheitlichen Krisen, nach schweren Verletzungen und Operationen durch Energiearbeit und mentale Stärkung.




In der Stadtwerkstatt bin ich mit meinen bisherigen zwei Büchern „Geht nicht - gibt’s nicht!“ und „Beziehungsweiser“ vertreten. Beide Bücher sind Geschichten aus dem echten Leben, die Mut machen und inspirieren. 




Mindestens ein Mal im Quartal kannst du mich in der Stadtwerkstatt auch live bei einem unterhaltsamen Buch-Abend erleben.




Und wenn du etwas Glück hast, triffst du mich auch einmal im Monat am Freitag beim Ladendienst.
`,
paypal:false,
},
{   index:12,
  id: 'Kati & Mario',
  name: "Kati Schmidt",
  description: 'Ka • Ma Jewelry – handgefertigter Schmuck, kombinierbar nach Lust & Laune!',
  backgroundImage: process.env.REACT_APP_PUBLIC_URL +'/Kati_Schmidt/juwelry6.png',
  portrait: process.env.REACT_APP_PUBLIC_URL +'/Kati_Schmidt/juwelry4.jpeg',
  images: [process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/juwelry1.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/juwelry2.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/juwelry3.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/juwelry5.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/juwelry.jpeg",
  process.env.REACT_APP_PUBLIC_URL +"/Kati_Schmidt/juwelry6.png"],
  socialLinks: {
    instagram: "https://www.instagram.com/ka_ma_jewelry/",
    facebook: "https://www.facebook.com/profile.php?id=100073333073365&ref=xav_ig_profile_web",
    website: "https://stadtwerkstatt-bautzen.de",
  },
leader:'KA•MA Jewelry',
address:'Blumenstraße 31, 02692 Doberschau',
email: 'meinert.kati@freenet.de',
mobile: '+49 176 50494712',
fon:'+49 3591 272668',
vatID:'204 269 02711',
descriptionInfo: 'Kleinunternehmerin iSv § 19 UStG',
detailedExpo:`
✨ Ka • Ma Jewelry – handgefertigter Schmuck, kombinierbar nach Lust & Laune! ✨




Wir sind Kati & Mario – viele von euch kennen uns bereits von Ka • Ma Homedesign.



Unsere Leidenschaft für kreative Designs und individuelle Gestaltung hat uns dazu inspiriert, ein neues Abenteuer zu starten: unser eigenes Schmucklabel Ka • Ma Jewelry – ein Label, das für Einzigartigkeit, Stil und Lebensfreude steht. 💕



Warum Ka • Ma Jewelry?



Wir glauben, dass Schmuck nicht nur ein Accessoire ist, sondern ein Ausdruck von Persönlichkeit und Kreativität.



Daher haben wir uns entschieden, handgefertigten Schmuck zu kreieren, der nicht nur schön anzusehen ist, sondern auch bequem und vielseitig kombinierbar ist.




💎 Was euch erwartet



Unser Sortiment ist eine Schatzkiste voller Farben und Formen.



Hier findet ihr alles – von einzigartigen Ohrringen über charmante Armbänder bis hin zu auffälligen Halsketten.



Jedes Schmuckstück wird von uns sorgfältig und mit viel Liebe zum Detail handgefertigt und erzählt seine ganz eigene Geschichte.



Egal, ob ihr einen besonderen Look für einen besonderen Anlass sucht oder euer tägliches Outfit mit einem kleinen Highlight aufwerten möchtet – bei uns ist für jeden etwas dabei.




🎨 Werde selbst kreativ bei unseren Workshops!



In der StadtWERKSTATT haben wir ein kreatives Paradies für euch geschaffen.



Hier könnt ihr nicht nur unsere Designs entdecken und kaufen, sondern auch selbst aktiv werden und euer ganz persönliches Schmuckstück gestalten.



Bei unseren Workshops habt ihr die Möglichkeit, aus einer Vielzahl an Einzelteilen euer individuelles Lieblingsstück zu kreieren – ganz nach euren Vorstellungen und Wünschen.



Ob Anfänger oder erfahrene Bastler: Jeder kann mitmachen!
Wir unterstützen euch mit Tipps und Tricks und begleiten euch dabei, eure eigenen Ideen in ein einzigartiges Schmuckstück zu verwandeln.




✨ Jeden Donnerstag: Unsere CHARM BAR



Und das Beste kommt zum Schluss:



Jeden Donnerstag von 14–17 Uhr ist unsere CHARM BAR in der StadtWERKSTATT geöffnet! 💕



Ganz ohne Anmeldung könnt ihr vorbeikommen, euch inspirieren lassen und aus vielen verschiedenen Charms, Anhängern und Einzelteilen euer ganz persönliches Schmuckstück zusammenstellen.



Kombinieren, ausprobieren, kreativ sein und einfach Spaß haben – ganz nach Lust & Laune!




💕 Ka • Ma Jewelry


Handgefertigt. Individuell. Kreativ. Ganz nach deinem Stil.


`,
paypal:false,
},

  ];
  export default TeamImpressumData;